export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4606.e4fa544d.jpg";